export function nextTabIndex(current, key, count) {
  switch (key) {
    case 'ArrowRight': return (current + 1) % count;
    case 'ArrowLeft': return (current - 1 + count) % count;
    case 'Home': return 0;
    case 'End': return count - 1;
    default: return current;
  }
}

if (globalThis.customElements && !customElements.get('b-tabs')) {
  customElements.define('b-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tablist"] [role="tab"]')].filter((t) => t.closest('b-tabs') === this);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const next = nextTabIndex(i, e.key, this.tabs.length);
          if (next !== i) { e.preventDefault(); this.select(next, true); }
        });
      });
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !selected;
      });
      if (focus) this.tabs[index].focus();
    }
  });
}
